import { Category } from "@/types";
import CategoryItem from "./CategoryItem";

interface CategoryProps {
    categories: Category[]
    onClick: (category: Category)=> void
};

const CategoryList: React.FC<CategoryProps> = ({categories, onClick})=> {
    return (
        <div className="row row-cols-4 g-4">
            {categories.map(category=> <CategoryItem key={category.name} category={category} onClick={onClick} />)}
        </div>
    )
};

export default CategoryList;